import { ClockCircleOutlined, FilterFilled } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Popconfirm,
  Popover,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import Busy from "../../image/Busy.svg";
import Callcenter from "../../image/Callcenter.svg";
import DealDone from "../../image/DealDone.svg";
import { ReactComponent as DownloadOutlined } from "../../image/DownloadOutlined.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { ReactComponent as Filtericon } from "../../image/FilterIcon.svg";
import OpenIcon from "../../image/OpenIcon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import Proposal from "../../image/Proposal.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import Delete from "../../image/trophy.png";
import Attendance from "../../image/Attendance.svg";
import Approach from "../../image/Approach.svg";
import ProposalRequestIcon from "../../image/ProposalRequestIcon.svg";
import TotalCount from "../../image/TotalCount.svg";
import award from "../../image/award.svg";
import PersonDiscard from "../../image/PersonDiscard.svg";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import RequestedDemoFilterModel from "./RequestedDemoFilterModel";
import RequestedDemoModel from "./RequestedDemoModel";
import RequestedStatusApproached from "./statusModal/RequestedStatusApproached";
import RequestedStatusAward from "./statusModal/RequestedStatusAward";
import RequestedStatusDiscard from "./statusModal/RequestedStatusDiscard";
import RequestedStatusProposal from "./statusModal/RequestedStatusProposal";
import timeline from "../../image/timeline.png";
import RequestedFollowUpModal from "./RequestedFollowUpModal";
import DemoStatus from "./DemoStatus";

const { Search } = Input;

const RequestedDemoList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const colors = ["#094E8F"];

  const { Option } = Select;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [requestedDemoList, setRequestedDemoList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [requesteddemoId, setRequestedDemoId] = useState(null);
  const [modalKey, setModalKey] = useState(false);

  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [requestedStatus, setRequestedStatus] = useState("");
  const [totalRequest, setTotalRequest] = useState(null);
  const [userId, setUserId] = useState(null);
  const [changeCurrentStatus, setCurrentChangeStatus] = useState("");
  const [demoMinDate, setDemoMinDate] = useState(null);
  const [demoMaxDate, setDemoMaxDate] = useState(null);
  const [requestMinDate, setRequestMinDate] = useState(null);
  const [requestMaxDate, setRequestMaxDate] = useState(null);
  const [flag, setFlag] = useState(false);
  const [resetFieldFilter, setResetFieldFilter] = useState(false);
  const [modalKeyFilter, setModalKeyFilter] = useState(false);
  const [modalKeyRefreshFilter, setModalKeyRefreshFilter] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [statusCounts, setStatusCounts] = useState({
    openCount: 0,
    contactedCount: 0,
    proposalSentCount: 0,
    dealDoneCount: 0,
    discardCount: 0,
    notServiceableCount: 0,
  });
  const [dotLoaded, setDotLoaded] = useState(false);
  const [selectedPrNumber, setSelectedPrNumber] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  // state initialistaion
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    status: "",
  });

  const handleHover = (prNumber) => {
    if (selectedPrNumber !== prNumber) {
      setSelectedPrNumber(prNumber);
    }
    setDotLoaded(false);
  };

  // Fetch Request Demo List API
  useEffect(() => {
    const getRequestdemoList = async () => {
      setLoading(true);

      try {
        let apiResponse;
        if (
          demoMinDate !== null ||
          demoMaxDate !== null ||
          requestMinDate !== null ||
          requestMaxDate !== null
        ) {
          apiResponse = await getRequest(
            `request-demo/?${
              demoMaxDate !== null ? `demo_date__gte=${demoMaxDate}` : ""
            }${demoMinDate !== null ? `&demo_date__lte=${demoMinDate}` : ""}${
              requestMaxDate !== null
                ? `request_date__gte=${requestMaxDate}`
                : ""
            }${
              requestMinDate !== null
                ? `&request_date__lte=${requestMinDate}`
                : ""
            }`,

            state
          );
        } else {
          apiResponse = await getRequest("request-demo/", state);
          setTotalRequest(apiResponse.data.count);
        }
        if (apiResponse.data.results.success) {
          setRequestedDemoList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_requested_demo_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getRequestdemoList();
  }, [state, reload, t, statusFilter, flag]);

  // function for selection of Row
  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  // function to manage the Table Change
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  // fuction for shorting the enum value
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company";
    }
    if (sortField === "phone_number" && sortOrder === "ascend") {
      sortingEnumKey = "phone_number";
    }
    if (sortField === "phone_number" && sortOrder === "descend") {
      sortingEnumKey = "-phone_number";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "no_of_buyer" && sortOrder === "ascend") {
      sortingEnumKey = "no_of_buyer";
    }
    if (sortField === "no_of_buyer" && sortOrder === "descend") {
      sortingEnumKey = "-no_of_buyer";
    }
    if (sortField === "about_company" && sortOrder === "ascend") {
      sortingEnumKey = "about_company";
    }
    if (sortField === "about_company" && sortOrder === "descend") {
      sortingEnumKey = "-about_company";
    }
    if (sortField === "request_date" && sortOrder === "ascend") {
      sortingEnumKey = "request_date";
    }
    if (sortField === "request_date" && sortOrder === "descend") {
      sortingEnumKey = "-request_date";
    }
    if (sortField === "demo_date" && sortOrder === "ascend") {
      sortingEnumKey = "demo_date";
    }
    if (sortField === "demo_date" && sortOrder === "descend") {
      sortingEnumKey = "-demo_date";
    }
    if (sortField === "day_count" && sortOrder === "ascend") {
      sortingEnumKey = "day_count";
    }
    if (sortField === "day_count" && sortOrder === "descend") {
      sortingEnumKey = "-day_count";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }

    return sortingEnumKey;
  };

  // function to add the request Demo Id
  const handleAdd = () => {
    setRequestedDemoId(null);
    showModal();
  };

  // function to handle the status
  const handleStatus = async (user_id, status) => {
    setUserId(user_id);
    setCurrentChangeStatus(status);
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("confirmAlert_message"),
      buttons: [
     
        {
          className:'ant-btn ant-btn-primary CancelGradiantBtn',
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/requested-demo"),
        },
        {
          className:'ant-btn ant-btn-primary BlueShadowBtn',
          label: t("confirmAlert_ok"),
          onClick: () => handleStatusPopup(user_id, status),
        },
      ],
    });
  };
  const handleStatusPopup = (user_id, value) => {
    if (value === "Proposal Sent") {
      showModalStatusProposal();
    } else if (value === "Approached") {
      showModalStatusApproached();
    } else if (value === "Award of Order") {
      showModalStatusAward();
    } else {
      showModalStatusDiscard();
    }
  };

  // Fetch the Status count API
  useEffect(() => {
    const getStatusCount = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("request-demo-status-count/", state);

        if (apiResponse.data.success) {
          const message = apiResponse.data.message;
          setStatusCounts({
            openCount: message.yet_to_attend_count,
            contactedCount: message.approached_count,
            proposalSentCount: message.proposal_sent_count,
            dealDoneCount: message.award_of_order_count,
            discardCount: message.to_be_discard_count,
            notServiceableCount: message.not_serviceable_count,
            totalCountCard: message.total_count,
          });
        } else {
          ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getStatusCount();
  }, [state, reload, t]);

  const handleEdit = (id) => {
    setModalKey((prevKey) => !prevKey);
    setRequestedDemoId(id);
    showModal();
  };

  const handleFollowupEdit = (id) => {
    setModalKey((prevKey) => !prevKey);
    setRequestedDemoId(id);
    showFollowUpModal();
  };

  // function to Filter Modal
  const handleFilter = () => {
    showModalFilter();
  };

  // function for refresing the data
  const handleRefresh = () => {
    setMaxDate(null);
    setMinDate(null);
    setRequestMaxDate(null);
    setRequestMinDate(null);
    setDemoMaxDate(null);
    setDemoMinDate(null);
    setSelectedCard(null);
    setRequestedStatus("");
    setStatusFilter("");
    setFilterApplied(false);
    setState({
      ...state,
      search: "",
      status: "",
      page: 1,
    });
    form.setFieldsValue({ search: "" });
    setModalKeyRefreshFilter((prevKey) => !prevKey);
  };
  const handleClickCard = (value) => {
    setMaxDate(null);
    setMinDate(null);
    setRequestMaxDate(null);
    setRequestMinDate(null);
    setDemoMaxDate(null);
    setDemoMinDate(null);
    setStatusFilter("");
    setResetFieldFilter(true);
    setFilterApplied(false);
    setSelectedCard(value);
    setState({
      ...state,
      search: "",
      status: value,
      page: 1,
    });
    form.setFieldsValue({ search: "" });
    setModalKeyFilter((prevKey) => !prevKey);
  };

  // function to handle the archive
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("request-demo-delete/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids?.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("requested_demo_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
        ErrorNotificationMsg(t("error_in_archive_requested_demo"));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    form.setFieldsValue({ search: value });
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    if (value) {
      setState({
        ...state,
        search: value,
      });
    } else {
      const { search, ...newState } = state; // Remove 'search' key from state
      setState(newState);
    }
  };
  const onSearchReset = (value) => {
    setState({
      ...state,
      search: "",
    });
  };

  const debounceLoadData = useCallback(
    debounce((value, onSearch) => {
      onSearch(value);
    }, 1000),
    []
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);
  const [isModal4Open, setIsModal4Open] = useState(false);
  const [isModal5Open, setIsModal5Open] = useState(false);
  const [isModal6Open, setIsModal6Open] = useState(false);

  const [isFollowUpModalOpen, setIsFollowUpModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const showFollowUpModal = () => {
    setIsFollowUpModalOpen(true);
  };
  const showModalFilter = () => {
    setIsModal2Open(true);
  };
  const showModalStatusProposal = () => {
    setIsModal3Open(true);
  };
  const showModalStatusApproached = () => {
    setIsModal4Open(true);
  };
  const showModalStatusAward = () => {
    setIsModal5Open(true);
  };
  const showModalStatusDiscard = () => {
    setIsModal6Open(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setIsModal2Open(false);
    setIsModal3Open(false);
    setIsModal4Open(false);
    setIsModal5Open(false);
    setIsModal6Open(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsModal2Open(false);
    setIsModal3Open(false);
    setIsModal4Open(false);
    setIsModal5Open(false);
    setIsModal6Open(false);
  };

  const handleCancel1 = () => {
    setIsFollowUpModalOpen(false);
  };

  const columns = [
    {
      title: "Status",
      width: "140px",
      dataIndex: "status",
      key: "status",
      render: (e, record) => (
        <div className="SelectStatusSec newSelectStatusSec">
          <Select
            value={e ? e : record.status}
            onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
          >
            <Select.Option value="Yet to Attend" disabled>
              <div className="openopt">Yet to attend</div>
            </Select.Option>

            <Select.Option value="Approached">
              <div className="contactedopt">Approached</div>
            </Select.Option>

            <Select.Option value="Proposal Sent">
              <div className="proposalopt">Proposal Sent</div>
            </Select.Option>

            <Select.Option value="Award of Order">
              <div className="dealdoneopt">Award of order</div>
            </Select.Option>

            <Select.Option value="To be Discard">
              <div className="discardopt">To Be Discard</div>
            </Select.Option>
          </Select>
        </div>
      ),
      sorter: true,
    },
    {
      title: "Prospect name",
      dataIndex: "company",
      sorter: true,
      key: "company",
      width: "100px",
    },

    {
      title: "Prospect Personnel",
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: "100px",
    },

    {
      title: "Contact Number",
      dataIndex: "phone_number",
      sorter: true,
      width: "100px",
      render: (phone_number) => {
        const countryCode = "91";
        const localNumber = phone_number.substring(countryCode.length);
        return (
          <>
            +{countryCode} {localNumber}
          </>
        );
      },

      key: "phone_number",
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      width: "150px",
      key: "email",
    },
    {
      title: "Request Date",
      dataIndex: "request_date",
      width: "100px",
      sorter: true,
      key: "request_date",
    },
    {
      title: "Demo Date",
      dataIndex: "demo_date",
      width: "120px",
      sorter: true,
      key: "demo_date",
    },
    {
      title: "Remarks",
      dataIndex: "remark",
      width: "120px",
      sorter: true,
      key: "remark",
    },
    {
      title: "Buyer Count",
      dataIndex: "no_of_buyer",
      width: "80px",
      sorter: true,
      key: "no_of_buyer",
    },
    {
      title: (
        <Tooltip
          color={colors}
          style={{ color: "#fff" }}
          title="Yet To Attend Aging"
        >
          YTA Aging
        </Tooltip>
      ),
      width: "100px",
      dataIndex: "day_count",
      sorter: false,
      key: "day_count",
    },
    {
      title: "Action",
      fixed: "right",
      width: "100px",
      key: "operation",
      render: (text, record) => {
        console.log('record', record);
        
        return (
        <Space>
          <Popover
            placement="left"
            content={
              <DemoStatus
                id={record.id}
                // CompanyID={CompanyID}
                // prID={record.id}
                setDotLoaded={setDotLoaded}
              />
            }
            title={`Status of ${record.company}`}
          >
            <ClockCircleOutlined
              onMouseEnter={() => handleHover(record.pr_number)}
              style={{ cursor: "pointer" }}
            />
          </Popover>
          {authUserData()?.permission.includes(
            "request_demo|change_requestdemo"
          ) && (
            <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Edit</span>}
            >
              <Editicon
                onClick={() => handleEdit(record.id)}
                style={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}
          {authUserData()?.permission.includes(
            "request_demo|change_requestdemo"
          ) && record.demo_date !== null && (
            <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Modify Follow Up</span>}
            >
              <img
                src={timeline}
                alt="timeline"
                onClick={() => handleFollowupEdit(record.id)}
                style={{ cursor: "pointer" }}
              ></img>
              {/* <Editicon
                  onClick={() => handleEdit(record.id)}
                  style={{ cursor: "pointer" }}
                /> */}
            </Tooltip>
          )}
          <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          >
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              {authUserData()?.permission.includes(
                "request_demo|delete_requestdemo"
              ) && <Archive style={{ cursor: "pointer" }} />}
            </Popconfirm>
          </Tooltip>
          {/* {record.proposal_sent_attachemnt !== null && (
            <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Offered Document</span>}
            >
              <a
                href={record.proposal_sent_attachemnt}
                target="_blank"
                rel="noreferrer"
              >
                <DownloadOutlined />
              </a>
            </Tooltip>
          )} */}
        </Space>
      )},
    },
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("pl_demo_request")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_demo_request")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            {authUserData()?.permission.includes(
              "request_demo|change_requestdemo"
            ) && (
              <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>Add New Demo Request</span>
                }
              >
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={handleAdd}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("Add Demo Request")}
                </Button>
              </Tooltip>
            )}
            <div className="searchwrp" style={{ height: "40px" }}>
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "request_demo|delete_requestdemo"
                ) && (
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                )}
              </Popconfirm>
            )}

            <Tooltip
              color={colors}
              placement="topLeft"
              title={<span style={{ color: "#fff" }}>Filter Records</span>}
            >
              <Link className="FilterIcon">
                <FilterFilled
                  style={{ fontSize: "38px !important" }}
                  onClick={() => handleFilter()}
                />
              </Link>
            </Tooltip>
            <Tooltip
              color={colors}
              placement="topLeft"
              title={<span style={{ color: "#fff" }}>Refresh Records</span>}
            >
              <Link>
                <Filtericon onClick={() => handleRefresh()} />
              </Link>
            </Tooltip>
            <Tooltip
              color={colors}
              placement="topLeft"
              title={
                <span style={{ color: "#fff" }}>View Archived Records</span>
              }
            >
              <Link to="/requested-demo/archive" className="Archiveicon">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Space>
        </div>
      </div>

      <section className="grid-sec tablegridsec">
        <div className="PR-body">
          <section className="Block-Sec-Demo1 mb-5">
          <Row gutter={[15]}>
    {[
      {
        status: "",
        title: "Total Request",
        count: statusCounts?.totalCountCard,
        icon: TotalCount,
      },
      {
        status: "Yet to Attend",
        title: "Yet To Attend",
        count: statusCounts?.openCount,
        icon: Attendance,
      },
      
      {
        status: "Approached",
        title: "Approached",
        count: statusCounts?.contactedCount,
        icon: Approach,
      },
      {
        status: "Proposal Sent",
        title: "Proposal Sent",
        count: statusCounts?.proposalSentCount,
        icon: ProposalRequestIcon,
      },
      {
        status: "Award of Order",
        title: "Award Of Order",
        count:statusCounts?.dealDoneCount,
        icon: award,
      },
      {
        status: "To be Discard",
        title: "To Be Discard",
        count: statusCounts?.discardCount,
        icon: PersonDiscard,
      },
    ].map((item, index) => (
      <Col key={index} xs={24} sm={12} md={8} lg={6} xl={4}>
        <div
          className={`card ${
            selectedCard === item.status ? "active" : ""
          }`}
          onClick={() => handleClickCard(item.status)}
        >
          <div className="card-block">
            <div className="card-box">
              <div className="card-icon">
                <img src={item.icon} alt={item.title} width={35} />
              </div>
              <div className="card-description">
                <h3>
                  {item.title}
                </h3>
                <p>{item.count}</p>
              </div>
            </div>
          </div>
        </div>
      </Col>
    ))}
  </Row>
            {/* <Row gutter={[15]}>
              <Col xs={24} sm={12} md={8} lg={6} xl={4} m-0>
                <div
                  className="card mb-5"
                  onClick={() => {
                    handleClickCard("");
                  }}
                >
                  <div className="card-block block-1">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={TotalCount} alt="Open" width={35} />
                      </div>
                      <div className="card-description">
                        <h3 className="color-blue"> Total Request</h3>
                        <p>
                          {state?.search !== ""
                            ? statusCounts?.totalCountCard
                            : totalRequest}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <div
                  className="card mb-5"
                  onClick={() => {
                    handleClickCard("Yet to Attend");
                  }}
                >
                  <div className="card-block block-2">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={Attendance} alt="Callcenter" width={35} />
                      </div>
                      <div className="card-description">
                        <h3 className="color-orange">Yet To Attend</h3>
                        <p>{statusCounts.openCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <div
                  className="card mb-5"
                  onClick={() => {
                    handleClickCard("Approached");
                  }}
                >
                  <div className="card-block block-3">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={Approach} alt="Proposal" width={35} />
                      </div>
                      <div className="card-description">
                        <h3 className="color-purpul">Approached </h3>

                        <p>{statusCounts.contactedCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <div
                  className="card mb-5"
                  onClick={() => {
                    handleClickCard("Proposal Sent");
                  }}
                >
                  <div className="card-block block-4">
                    <div className="card-box">
                      <div className="card-icon">
                        <img
                          src={ProposalRequestIcon}
                          alt="DealDone"
                          width={35}
                        />
                      </div>
                      <div className="card-description">
                        <h3 className="color-green">Proposal Sent</h3>
                        <p>{statusCounts.proposalSentCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <div
                  className="card mb-5"
                  onClick={() => {
                    handleClickCard("Award of Order");
                  }}
                >
                  <div className="card-block block-5">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={award} alt="Delete" width={35} />
                      </div>
                      <div className="card-description">
                        <h3 className="color-gry">Award Of Order</h3>
                        <p>{statusCounts.dealDoneCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <div
                  className="card mb-4"
                  onClick={() => {
                    handleClickCard("To be Discard");
                  }}
                >
                  <div className="card-block block-6">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={PersonDiscard} alt="Busy" width={35} />
                      </div>
                      <div className="card-description">
                        <h3 className="color-red">To Be Discard</h3>
                        <p>{statusCounts.discardCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row> */}
          </section>
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            ></Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} className="tbl-action">
              <Modal
                className="ModelPopupSecDemo"
                title={t("pl_requested_demo")}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[]}
                closable={false}
                keyboard={false}
                wrapClassName="modal-wrapper"
              >
                <RequestedDemoModel
                  handleCancel={handleCancel}
                  setReload={setReload}
                  form={form}
                  reload={reload}
                  requesteddemoId={requesteddemoId}
                  setRequestedDemoId={setRequestedDemoId}
                  modalKey={modalKey}
                  setStateList={setState}
                  stateList={state}
                  handleRefresh={handleRefresh}
                />
              </Modal>

              <Modal
                className="ModelPopupSecFilter"
                title={t("pl_requested_demo_filter")}
                open={isModal2Open}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[]}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <RequestedDemoFilterModel
                  filterApplied={filterApplied}
                  setFilterApplied={setFilterApplied}
                  modalKeyFilter={modalKeyFilter}
                  setModalKeyFilter={setModalKeyFilter}
                  modalKeyRefreshFilter={modalKeyRefreshFilter}
                  setModalKeyRefreshFilter={setModalKeyRefreshFilter}
                  setStateM={setState}
                  stateList={state}
                  form={form}
                  handleCancel={handleCancel}
                  setResetFieldFilter={setResetFieldFilter}
                  resetFieldFilter={resetFieldFilter}
                  setStatusFilter={setStatusFilter}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  setRequestedStatus={setRequestedStatus}
                  startDate={startDate}
                  endDate={endDate}
                  requestedStatus={requestedStatus}
                  setRequestMaxDate={setRequestMaxDate}
                  setRequestMinDate={setRequestMinDate}
                  setDemoMaxDate={setDemoMaxDate}
                  setDemoMinDate={setDemoMinDate}
                  setFlag={setFlag}
                />
              </Modal>

              <Modal
                className="ModelPopupSec"
                title={t("pl_requested_status_proposal")}
                open={isModal3Open}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[]}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <RequestedStatusProposal
                  setReload={setReload}
                  userId={userId}
                  changeCurrentStatus={changeCurrentStatus}
                  handleCancel={handleCancel}
                  reload={reload}
                />
              </Modal>
              <Modal
                className="ModelPopupSec"
                title={t("pl_requested_status_approached")}
                open={isModal4Open}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[]}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <RequestedStatusApproached
                  userId={userId}
                  changeCurrentStatus={changeCurrentStatus}
                  handleCancel={handleCancel}
                  setReload={setReload}
                  reload={reload}
                />
              </Modal>
              <Modal
                className="ModelPopupSec"
                title={t("pl_requested_status_award")}
                open={isModal5Open}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[]}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <RequestedStatusAward
                  userId={userId}
                  changeCurrentStatus={changeCurrentStatus}
                  handleCancel={handleCancel}
                  setReload={setReload}
                  reload={reload}
                />
              </Modal>
              <Modal
                className="ModelPopupSec"
                title={t("pl_requested_status_discard")}
                open={isModal6Open}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[]}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <RequestedStatusDiscard
                  userId={userId}
                  changeCurrentStatus={changeCurrentStatus}
                  handleCancel={handleCancel}
                  setReload={setReload}
                  reload={reload}
                />
              </Modal>
            </Col>

            <Modal
              className="ModelPopupSecDemo abc"
              title={t("Follow Up")}
              open={isFollowUpModalOpen}
              onOk={handleOk}
              onCancel={handleCancel1}
              footer={[]}
              closable={handleCancel1}
              keyboard={false}
              style={{ width: "700px !important" }}
              // wrapClassName="modal-wrapper"
            >
              <RequestedFollowUpModal
                handleCancel={handleCancel1}
                setReload={setReload}
                form={form}
                reload={reload}
                requesteddemoId={requesteddemoId}
                setRequestedDemoId={setRequestedDemoId}
                modalKey={modalKey}
                setStateList={setState}
                stateList={state}
                handleRefresh={handleRefresh}
              />
            </Modal>
          </Row>
<div className="tablewrp">
          <Table
            scroll={{
              x: 2100,
            }}
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={requestedDemoList}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
    </>
  );
};

export default RequestedDemoList;
